<template>
    <th class="sortable" @click="sort">
        <div class="table-column">
            <slot></slot>
            <div class="sort-handler" v-if="sortable">
                <div class="sort-asc" v-bind:class="{
                    active:
                        grid.sortingBy.attr === attr &&
                        grid.sortingBy.method === 'asc',
                }"></div>
                <div class="sort-desc" v-bind:class="{
                    active:
                        grid.sortingBy.attr === attr &&
                        grid.sortingBy.method === 'desc',
                }"></div>
            </div>
        </div>

    </th>
</template>
<style lang="scss">
.grid .table thead th.sortable {
    .table-column {
        display: inline-block;
        position: relative;
        padding-right: 20px;
    }

    .sort-handler {
        position: absolute;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-left: 0;
        top: 50%;
        right: 0;
        transform: translateY(-50%);

        .sort-asc,
        .sort-desc {
            width: 12px;
            height: 12px;
            background-color: currentColor;
            border: none;
            margin: 0;
            /* usa a cor do texto */
            display: inline-block;
            -webkit-mask-image: url("data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M6%209L12%2015L18%209%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E");
            mask-image: url("data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M6%209L12%2015L18%209%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E");

            &:not(.active) {
                opacity: 0.5;
            }
        }

        .sort-asc {
            transform: rotate(180deg);
        }
    }
}
</style>

<script>
export default {
    name: "grid-th",
    props: {
        attr: String,
        sortable: {
            type: Boolean,
            default: false,
        },
        grid: Object,

    },
    methods: {
        sort() {
            if (this.sortable) {
                this.grid.sort(this.attr);
            }
        },
    },
};
</script>
